<template>
    <div class="container-fluid details-container-overflow">
            <DamDataUpdater
                v-if="currentDamSelected"
                :key="currentDamSelectedName"
            ></DamDataUpdater>
            <div class="details-container-title-wrapper">
                <RightPanelContainerName></RightPanelContainerName>
                <RightPanelContainerCoordinates></RightPanelContainerCoordinates>
                <RightPanelContainerIcons></RightPanelContainerIcons>
            </div>
            <RightPanelContainerSensorsList></RightPanelContainerSensorsList>
            <RightPanelDetails></RightPanelDetails>
        </div>
</template>

<script>
    // utils
    import {mapGetters} from "vuex";
    // components
    import DamDataUpdater from "../shared/DamDataUpdater";
    import RightPanelContainerName from "./RightPanelContainerName";
    import RightPanelContainerCoordinates from "./RightPanelContainerCoordinates";
    import RightPanelContainerIcons from "./RightPanelContainerIcons";
    import RightPanelContainerSensorsList from "./RightPanelContainerSensorsList";
    import RightPanelDetails from "./RightPanelDetails";

    /**
     * The right side panel holds information for
     * the selected station - name, status, location,
     * main set of sensors like circular icons and
     * lists the 4 types of meters.
     */

    export default {
        name: "RightPanelContainer",
        components: {
            DamDataUpdater,
            RightPanelContainerName,
            RightPanelContainerCoordinates,
            RightPanelContainerIcons,
            RightPanelContainerSensorsList,
            RightPanelDetails
        },
        computed: {
            ...mapGetters(['currentDamSelected', 'currentDamSelectedName']),
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .details-container {
        &-overflow {
            // height: calc(100% - 65px);
            // overflow-y: auto;
            height: 100%;
            display: flex;
            flex-direction: column;
            min-height: 0;
        }
    }

</style>